/*! (c) Andrea Giammarchi - ISC */
//var importNode=function(e,o,n,d,t){var r="importNode"in e,c=e.createDocumentFragment();return c.appendChild(e.createTextNode("g")),c.appendChild(e.createTextNode("")),(r?e.importNode(c,!0):c.cloneNode(!0)).childNodes.length<2?function i(e,o){for(var n=e.cloneNode(),d=e.childNodes||[],t=d.length,r=0;o&&r<t;r++)n.appendChild(i(d[r],o));return n}:r?e.importNode:function(e,o){return e.cloneNode(!!o)}}(document);

$(function () {
    var parent = $('[data-api]');
    var api = parent.data('api');

    if (api && api.length) {
        var tmpl = document.querySelector('#tmpl-item');
        var itemsContainer = parent.find('[data-items]');
        var btnLoadMore = parent.find('[data-btn-loadmore]');
        var btnFilter = parent.find('[data-filter]');
        var spinner = parent.find('[data-spinner]');
        var filter = JSON.parse(parent.attr('data-api-filter'));
        var apiData = JSON.parse(parent.attr('data-api-data'));
        var apiType = parent.attr('data-api-type');

        apiCall(true);


        btnLoadMore.on('click', function (event) {
            event.preventDefault();
            filter.page++;
            apiCall(false);
        });

        btnFilter.on('click', function (event) {
            event.preventDefault();
            btnFilter.removeClass('active');
            $(this).addClass('active');
            filter.type = $(this).attr('data-filter');
            filter.page = 1;
            apiCall(true);
        })

        $('select[data-filter]').on('select2:select', function (e) {
            var data = e.params.data.id;
            var id = data.split("--")[0];
            var value = data.split("--")[1];
            apiData[id] = value;
            apiData['filter'] = 'true';
            apiCall(true);
        });
    }

    function apiCall(reset) {

        console.log('FILTER');
        console.log(filter);
        console.log('apiData');
        console.log(apiData);

        var apiTmp = api;
        apiTmp = apiTmp.replace("#TYPE#", filter.type);
        apiTmp = apiTmp.replace("#PAGE#", filter.page);
        $.ajax({
                type: apiType ? apiType : 'POST',
                url: apiTmp,
                data: apiData,
                beforeSend: function () {
                    loadingStart();
                }
            })
            .done(function (result) {
                if (reset) {
                    deleteItems();
                }
                console.log('DEBUG:');
                console.log(result.debug);
                var isArray = Array.isArray(result.items);
                if (isArray) {
                    updateItems(result);
                }

                if (result.finished) {
                    finish();
                } else {
                    btnLoadMore.show();
                }
            })
            .fail(function (result) {
                var errorMsg = result.message;
                itemsContainer.append('<p class="col my-2 text-danger">' + errorMsg + '</p>');
                console.warn(result);
            })
            .always(function () {
                loadingStop();
            });
    }

    function finish() {
        btnLoadMore.hide();
    }

    function loadingStart() {
        spinner.show();
        parent.addClass('loading');
    }

    function loadingStop() {
        spinner.hide();
        parent.removeClass('loading');
    }

    function deleteItems() {
        itemsContainer.empty();
    }

    function updateItems(result) {
        var items = result.items;
        for (let i = 0; i < items.length; i++) {
            var item = items[i];

            // var clone = document.importNode(tmpl.content, true);
            var clone = $($(tmpl).html())[0];
            clone.querySelector('[data-tmpl-id]').setAttribute('id', item.id);

            var textBlocks = clone.querySelectorAll('[data-tmpl-text]');
            for (let index = 0; index < textBlocks.length; index++) {
                var block = textBlocks[index];
                var value = block.getAttribute('data-tmpl-text');
                block.innerHTML = item[value];
            }

            var attrBlocks = clone.querySelectorAll('[data-tmpl-attr]');
            for (let index = 0; index < attrBlocks.length; index++) {
                var block = attrBlocks[index];
                var attrValue = block.getAttribute('data-tmpl-attr').split(',');
                block.setAttribute(attrValue[0], item[attrValue[1]]);
            }

            itemsContainer.append(clone);

        }
    }
});
